/**
 * <nia-sticky-atc>
 * Barra de compra fija en móvil. Aparece cuando el botón principal del buy box
 * sale de la pantalla y se sincroniza con <nia-buy-options>.
 *
 * No agrega por su cuenta: reenvía el formulario del buy box con
 * requestSubmit(), así el alta, los estados y la apertura del carrito viven en
 * un solo sitio y no hay dos implementaciones que puedan divergir.
 */
class NiaStickyAtc extends HTMLElement {
  connectedCallback() {
    this.optionEl = this.querySelector('[data-sticky-option]');
    this.button = this.querySelector('[data-sticky-submit]');

    // Las dos etiquetas vienen de los ajustes de la seccion. Antes se sacaba
    // la primera partiendo el texto del boton por el guion largo, que ademas
    // de fragil no daba forma de saber como llamar a la suscripcion.
    this.labels = {
      add: this.dataset.label || 'Agregar',
      subscribe: this.dataset.labelSubscribe || 'Suscribirme',
    };

    this.button?.addEventListener('click', this.#onClick);
    document.addEventListener('nia:buy-options:change', this.#onChange);

    // Si el buy box se activo primero, su primer aviso ya paso: se recoge el
    // estado que dejo guardado en vez de esperar al siguiente cambio.
    const buy = document.querySelector('nia-buy-options');
    if (buy?.lastChange) this.#paint(buy.lastChange);

    this.#watch();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener('nia:buy-options:change', this.#onChange);
  }

  /** El botón principal del buy box es el disparador. */
  #watch() {
    const anchor = document.querySelector('[data-buy-atc]');
    if (!anchor || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const visible = !entry.isIntersecting;
        this.classList.toggle('is-visible', visible);
        // Lo lee el CSS del botón de chat para apartarse.
        document.body.classList.toggle('nia-sticky-on', visible);
      },
      { threshold: 0 }
    );
    this.observer.observe(anchor);
  }

  #onChange = (event) => {
    if (event.detail) this.#paint(event.detail);
  };

  /**
   * La barra solo copia cadenas: el precio llega ya formateado por el buy box
   * y el nombre de la opcion ya compuesto por Liquid, asi que ni el formato de
   * moneda ni la frase de cantidad se reimplementan aqui.
   *
   * La etiqueta cambia con el tipo de compra: anunciar "Agregar" mientras esta
   * elegida la suscripcion haria creer que es una compra unica.
   */
  #paint({ price, available, subscription, optionName }) {
    if (!this.button) return;

    const label = subscription ? this.labels.subscribe : this.labels.add;
    if (price) this.button.textContent = `${label} — ${price}`;
    this.button.disabled = available === false;

    if (this.optionEl && optionName) this.optionEl.textContent = optionName;
  }

  #onClick = () => {
    const form = document.getElementById('nia-product-form');
    if (form instanceof HTMLFormElement) form.requestSubmit();
  };
}

if (!customElements.get('nia-sticky-atc')) {
  customElements.define('nia-sticky-atc', NiaStickyAtc);
}
